<h2 mat-dialog-title>Future Price Tiers</h2>

<!-- TODO: Need to show the effective from date in table -->
<!-- NOTE: We may be able to move to inline edits -->
<!-- TODO: Set a min height for modal -->

<mat-dialog-content class="mat-typography">
    <div class="col-12 mb-5 table-responsive">
        <table mat-table [dataSource]="dataSource" class="w-100">
            <ng-container matColumnDef="tier">
                <th mat-header-cell *matHeaderCellDef> Tier </th>
                <td mat-cell *matCellDef="let row"> {{ row.tier }} </td>
            </ng-container>

            <ng-container matColumnDef="operative_cost">
                <th mat-header-cell *matHeaderCellDef> Operative Cost (£) </th>
                <td mat-cell *matCellDef="let row"> {{ row.operative_cost | currency:'GBP':'symbol':'1.2-2' }} </td>
            </ng-container>

            <ng-container matColumnDef="subcontractor_cost">
                <th mat-header-cell *matHeaderCellDef> Sub Contractor Cost (£) </th>
                <td mat-cell *matCellDef="let row"> {{ row.subcontractor_cost | currency:'GBP':'symbol':'1.2-2' }} </td>
            </ng-container>

            <ng-container matColumnDef="material_cost">
                <th mat-header-cell *matHeaderCellDef> Material Cost (£) </th>
                <td mat-cell *matCellDef="let row"> {{ row.material_cost | currency:'GBP':'symbol':'1.2-2' }} </td>
            </ng-container>

            <ng-container matColumnDef="sell_price">
                <th mat-header-cell *matHeaderCellDef> Sell (£) </th>
                <td mat-cell *matCellDef="let row"> {{ row.sell_price | currency:'GBP':'symbol':'1.2-2' }} </td>
            </ng-container>

            <ng-container matColumnDef="effective_from">
                <th mat-header-cell *matHeaderCellDef> Effective From </th>
                <td mat-cell *matCellDef="let row"> {{ row.effective_from | date:'dd/MM/yyyy' }} </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let row; let i = index">
                    <button mat-icon-button color="primary" (click)="editPriceTier(row)">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" (click)="deletePriceTier(row)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns;" [ngClass]="{'highlight-bg': row.edited}"></tr>

            <!-- No data message -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell text-center" [attr.colspan]="displayColumns.length">
                    No pricing tiers found
                </td>
            </tr>
        </table>

        <mat-paginator [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)">
        </mat-paginator>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
